var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomaticTesting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4546 5.50001H11.2079L7.24788 14.6667H9.08122L9.75038 12.8333H13.9121L14.5812 14.6667H16.4146L12.4546 5.50001ZM10.2729 11.4583L11.8312 7.33334L13.3896 11.4583H10.2729ZM16.7812 18.7L18.2479 20.1667H13.6646V15.5833L15.4979 17.4167C17.6887 16.1425 19.1646 13.7042 19.1646 11C19.1646 6.95751 15.8737 3.66668 11.8312 3.66668C7.78872 3.66668 4.49788 6.95751 4.49788 11C4.49788 13.7042 5.97372 16.0692 8.16455 17.3433V19.3967C4.92872 17.9758 2.66455 14.7583 2.66455 11C2.66455 5.95834 6.78955 1.83334 11.8312 1.83334C16.8729 1.83334 20.9979 5.95834 20.9979 11C20.9979 14.2358 19.3204 17.0683 16.7812 18.7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomaticTesting);
export default __webpack_public_path__ + "static/media/automatic-testing.2fafcb9e4d06208c83e7a2d9a8bbb768.svg";
export { ForwardRef as ReactComponent };